// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"252768cd","455":"12150bb5","869":"4af2ed06","977":"a6558b1d"}[chunkId] + ".chunk.js";
};